import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["group", "content", "datepicker", "addVisitorBtn", "removeVisitorBtn", "formContent", "successBlock"]

    connect() {
        this.visitorCounter = 0
        this.updateVisitorButtons()

        const originalDatepicker = this.datepickerTargets[0];
        this.minDate = originalDatepicker.querySelector('input').dataset.minDate;
        this.maxDate = originalDatepicker.querySelector('input').dataset.maxDate;

        // Add event listener for form submission success
        this.element.querySelector('form').addEventListener('success', this.handleFormSuccess.bind(this))
    }

    add(event) {
        event.preventDefault()

        const newIndex = this.contentTargets.length
        if (newIndex >= 5) return // was decided to allow a maximum of 5 visitors to be added

        this.visitorCounter++
        const newContent = this.contentTargets[0].cloneNode(true)

        newContent.dataset.visitorId = this.visitorCounter

        newContent.querySelectorAll('[name]').forEach(input => {
            input.name = input.name.replace(/\[0\]/, `[${newIndex}]`)
        })

        newContent.querySelectorAll('input').forEach(input => {
            input.value = ''
        })

        const datepickerElement = newContent.querySelector('[data-queue-repeater-target="datepicker"]')
        if (datepickerElement) {
            datepickerElement.innerHTML = ''
            const newDatepicker = this.createNewDatepicker(newIndex)
            datepickerElement.appendChild(newDatepicker)
        }

        this.groupTarget.appendChild(newContent)
        this.initializeDatepicker(newContent)
        this.updateVisitorButtons()
    }


    removeVisitor(event) {
        event.preventDefault()
        const visitorContent = event.target.closest('[data-queue-repeater-target="content"]')
        visitorContent.remove()
        this.updateIndices()
        this.updateVisitorButtons()
    }

    updateVisitorButtons() {
        const visitorCount = this.contentTargets.length
        this.addVisitorBtnTarget.disabled = visitorCount >= 5
        this.removeVisitorBtnTargets.forEach((btn, index) => {
            btn.disabled = visitorCount === 1
            btn.style.display = index === 0 && visitorCount === 1 ? 'none' : 'block'
        })
    }

    updateIndices() {
        this.contentTargets.forEach((content, index) => {
            content.querySelectorAll('[name]').forEach(input => {
                input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
            })
        })
    }

    createNewDatepicker(index) {
        const div = document.createElement('div')
        div.className = 'flatpickr'
        div.setAttribute('data-controller', 'datepicker')

        const input = document.createElement('input')
        input.type = 'hidden'
        input.className = 'input input-calendar w-full flatpickr-input'
        input.name = `visitors[${index}][birthday]`
        input.setAttribute('data-input', '')
        input.setAttribute('data-datepicker-target', 'input')
        input.setAttribute('data-action', 'datepicker#update')
        input.setAttribute('data-min-date', this.minDate);
        input.setAttribute('data-max-date', this.maxDate);

        div.appendChild(input)

        return div
    }

    initializeDatepicker(content) {
        const application = this.application
        const datepickerElement = content.querySelector('[data-controller="datepicker"]')
        if (datepickerElement) {
            application.getControllerForElementAndIdentifier(datepickerElement, 'datepicker')
        }
    }

    handleFormSuccess(event) {
        event.preventDefault()

        if (this.hasFormContentTarget) {
            this.formContentTarget.classList.add('d-none')
        }

        if (this.hasSuccessBlockTarget) {
            this.successBlockTarget.classList.remove('d-none')
        }
    }
}
